<template>
  <div
    class="schedule-panel shadow"
    @click="$emit('to-order-detail', data)"
  >
    <van-row
      gutter="10"
      v-if="orderType == 11007"
    >
      <van-col span="6">
        <img
          width="100%"
          src="~Components/Dynamic/default/images/hotel.png"
        >
      </van-col>
      <van-col span="13">
        <p class="font16 van-ellipsis">
          {{ data.departCityName }} - {{ data.voyageZh }}
        </p>
        <p
          class="font12 gray van-ellipsis"
          style="margin-top: 12px;"
        >
          <ld-icon type="icondibiao" />
          {{ data.scdd }}
        </p>
        <p
          class="font12 van-ellipsis"
          style="margin-top: 8px;"
        >
          {{ data.departTime | substring(5, 10) }}入住&nbsp;&nbsp;{{ data.ldrq | substring(5, 10) }}离店
        </p>
      </van-col>
      <van-col
        v-if="findScope == 1"
        span="5"
        class="font16 font-bold light-green text-right"
      >
        待入住
      </van-col>
    </van-row>

    <div v-if=" orderType == 11003 || orderType == 11004 || orderType == 11006 || orderType == 11009 || orderType == 11011">
      <van-row
        type="flex"
        align="center"
      >
        <van-col span="20">
          <span class="font16">
            {{ data.voyageZh }}
          </span>
          <span class="gray">
            {{ data.departDate }}（{{ formatDate(data.departDate).week }}）
          </span>
        </van-col>
        <van-col
          v-if="findScope == 1"
          span="4"
          class="font16 font-bold light-green"
        >
          待出行
        </van-col>
      </van-row>

      <van-row
        type="flex"
        align="center"
        style="margin-top: 8px;"
      >
        <van-col span="10">
          <div class="font20 gray">
            {{ data.departTime }}
          </div>
          <div
            class="gray"
            style="margin-top: 4px;"
          >
            {{ data.departAirportName }} {{ data.departTerminal }}
          </div>
        </van-col>
        <van-col
          span="4"
          class="text-center"
        >
          <img
            width="36"
            :src="orderType == 11009 || orderType == 11011 ? tr_link : tk_link"
          >
          {{ data.flightNo }}
          <span
            v-if="data.qxywbs == 1"
            class="font12 red"
          >飞机延误</span>
        </van-col>

        <van-col
          span="10"
          class="text-right"
        >
          <div class="font20 gray">
            {{ data.arriveTime }}
          </div>
          <div
            class="gray"
            style="margin-top: 4px;"
          >
            {{ data.arriveAirportName }} {{ data.arriveTerminal }}
          </div>
        </van-col>
      </van-row>
    </div>

    <!--联程订单布局-->
    <div v-show="data.orderType==11001 || orderType == 11003 ">
      <div v-if="data.voyageType==1">
        <div>
          <div class="gobeyond">
            <van-row
              type="flex"
              align="center"
            >
              <div
                v-for="(itme,index) in data.orderRangeBeanList"
                :key="index"
                class="AlistOfSchedules"
              >
                <van-row
                  type="flex"
                  align="center"
                >
                  <van-col span="20">
                    <span class="font16">
                      {{ itme.voyageZh }}
                    </span>
                    <span class="gray">
                      {{ itme.departDate }}（{{ formatDate(itme.departDate).week }}）
                    </span>
                  </van-col>
                  <van-col
                    v-if="findScope == 1"
                    span="4"
                    class="font16 font-bold light-green"
                  >
                    待出行
                  </van-col>
                </van-row>
                <van-row
                  type="flex"
                  align="center"
                  style="margin-top: 8px;"
                >
                  <van-col span="10">
                    <div class="font20 gray">
                      {{ itme.departTime }}
                    </div>
                    <div
                      class="gray"
                      style="margin-top: 4px;"
                    >
                      {{ itme.departAirportName }} {{ itme.departTerminal }}
                    </div>
                  </van-col>
                  <van-col
                    span="4"
                    class="text-center"
                  >
                    <img
                      width="36"
                      :src="orderType == 11009 || orderType == 11011 ? tr_link : tk_link"
                    >
                    {{ itme.flightNo }}
                    <span
                      v-if="itme.qxywbs == 1"
                      class="font12 red"
                    >飞机延误</span>
                  </van-col>

                  <van-col
                    span="10"
                    class="text-right"
                  >
                    <div class="font20 gray">
                      {{ itme.arriveTime }}
                    </div>
                    <div
                      class="gray"
                      style="margin-top: 4px;"
                    >
                      {{ itme.arriveAirportName }} {{ itme.arriveTerminal }}
                    </div>
                  </van-col>
                </van-row>
              </div>
            </van-row>
          </div>
        </div>
      </div>
      <div v-else-if="data.voyageType==2">
        <div>
          <div class="gobeyond">
            <van-row
              type="flex"
              align="center"
            >
              <div
                v-for="(itme,index) in data.orderRangeBeanList"
                :key="index"
                class="AlistOfSchedules"
              >
                <van-row
                  type="flex"
                  align="center"
                >
                  <van-col span="20">
                    <span class="font16">
                      {{ itme.voyageZh }}
                    </span>
                    <span class="gray">
                      {{ itme.departDate }}（{{ formatDate(itme.departDate).week }}）
                    </span>
                  </van-col>
                  <van-col
                    v-if="findScope == 1"
                    span="4"
                    class="font16 font-bold light-green"
                  >
                    待出行
                  </van-col>
                </van-row>
                <van-row
                  type="flex"
                  align="center"
                  style="margin-top: 8px;"
                >
                  <van-col span="10">
                    <div class="font20 gray">
                      {{ itme.departTime }}
                    </div>
                    <div
                      class="gray"
                      style="margin-top: 4px;"
                    >
                      {{ itme.departAirportName }} {{ itme.departTerminal }}
                    </div>
                  </van-col>
                  <van-col
                    span="4"
                    class="text-center"
                  >
                    <img
                      width="36"
                      :src="orderType == 11009 || orderType == 11011 ? tr_link : tk_link"
                    >
                    {{ itme.flightNo }}
                    <span
                      v-if="itme.qxywbs == 1"
                      class="font12 red"
                    >飞机延误</span>
                  </van-col>

                  <van-col
                    span="10"
                    class="text-right"
                  >
                    <div class="font20 gray">
                      {{ itme.arriveTime }}
                    </div>
                    <div
                      class="gray"
                      style="margin-top: 4px;"
                    >
                      {{ itme.arriveAirportName }} {{ itme.arriveTerminal }}
                    </div>
                  </van-col>
                </van-row>
              </div>
            </van-row>
          </div>
        </div>
      </div>
      <div
        class="Multi-reach"
        v-else-if="data.voyageType==3"
      >
        <div>
          <div class="gobeyond">
            <van-row
              type="flex"
              align="center"
            >
              <div
                v-for="(itme,index) in data.orderRangeBeanList"
                :key="index"
                class="AlistOfSchedules"
              >
                <van-row
                  type="flex"
                  align="center"
                >
                  <van-col span="20">
                    <span class="font16">
                      {{ itme.voyageZh }}
                    </span>
                    <span class="gray">
                      {{ itme.departDate }}（{{ formatDate(itme.departDate).week }}）
                    </span>
                  </van-col>
                  <van-col
                    v-if="findScope == 1"
                    span="4"
                    class="font16 font-bold light-green"
                  >
                    待出行
                  </van-col>
                </van-row>
                <van-row
                  type="flex"
                  align="center"
                  style="margin-top: 8px;"
                >
                  <van-col span="10">
                    <div class="font20 gray">
                      {{ itme.departTime }}
                    </div>
                    <div
                      class="gray"
                      style="margin-top: 4px;"
                    >
                      {{ itme.departAirportName }} {{ itme.departTerminal }}
                    </div>
                  </van-col>
                  <van-col
                    span="4"
                    class="text-center"
                  >
                    <img
                      width="36"
                      :src="orderType == 11009 || orderType == 11011 ? tr_link : tk_link"
                    >
                    {{ itme.flightNo }}
                    <span
                      v-if="itme.qxywbs == 1"
                      class="font12 red"
                    >飞机延误</span>
                  </van-col>

                  <van-col
                    span="10"
                    class="text-right"
                  >
                    <div class="font20 gray">
                      {{ itme.arriveTime }}
                    </div>
                    <div
                      class="gray"
                      style="margin-top: 4px;"
                    >
                      {{ itme.arriveAirportName }} {{ itme.arriveTerminal }}
                    </div>
                  </van-col>
                </van-row>
              </div>
            </van-row>
          </div>
        </div>
      </div>
    </div>

    <div v-if="orderType==11018">
      <van-row
        type="flex"
        align="center"
      >
        <van-col span="20">
          <span class="font16">
            {{ data.voyageZh }}-{{ data.productType | carproductType }}
          </span>
          <span class="gray">
            {{ data.departDate }}（{{ formatDate(data.departDate).week }}）
          </span>
        </van-col>
        <van-col
          v-if="findScope == 1"
          span="4"
          class="font16 font-bold light-green"
        >
          待出行
        </van-col>
      </van-row>

      <van-row
        type="flex"
        style="margin-top: 8px;"
      >
        <van-col span="10">
          <div class="font18 font-bold van-ellipsis">
            {{ data.scdd }}
          </div>
          <div
            class="gray"
            style="margin-top: 4px;"
          >
            {{ data.cabinName }}
          </div>
        </van-col>
        <van-col
          span="4"
          class="text-center"
        >
          <img
            width="36"
            :src="car_link"
          >
        </van-col>
        <van-col
          span="10"
          class="text-right"
        >
          <div class="font18 font-bold van-ellipsis">
            {{ data.xcdd }}
          </div>
        </van-col>
      </van-row>
    </div>


    <van-row
      gutter="10"
      v-if="orderType==11028 || orderType==11029 || orderType==11030 || orderType==11031"
    >
      <van-col span="6">
        <ld-icon
          class="main-color"
          size="56"
          :type="orderType | icon"
        />
      </van-col>
      <van-col span="13">
        <p class="font16 van-ellipsis">
          {{ data.departCityName }} - {{ data.voyageZh }}
        </p>
        <p
          class="font12 gray van-ellipsis"
          style="margin-top: 12px;"
        >
          <ld-icon type="iconjichang" />
          {{ data.scdd }}
        </p>
        <p
          class="font12 main-color van-ellipsis"
          style="margin-top: 8px;"
        >
          待使用
        </p>
      </van-col>
    </van-row>
  </div>
</template>
<script>
import { Image } from 'vant'

import tk_link from '../images/tk-link.png'
import tr_link from '../images/tr-link.png'
import car_link from '../images/car-link.png'
import { formatDate } from '@/business/utils/dateUtil'
import mixin from 'Views/Home/allorder/components/orderMixin'

export default {
  name: 'SchedulePanel',
  mixins: [mixin],
  components: {
    [Image.name]: Image,
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    orderType: {
      type: [String, Number],
      default: 11001
    },
    findScope: {
      type: [String, Number],
      default: 1,
    }
  },
  data () {
    return {
      tk_link, tr_link, car_link,
      list_1:[
        {
          'bookDate': '2023-05-11 16:18:06',
          'departDate': '2023-05-13',
          'departTime': '07:30',
          'arriveDate': '2023-05-13',
          'arriveTime': '14:55',
          'departCityName': '乌鲁木齐',
          'arriveCityName': '厦门',
          'departAirportName': '地窝堡机场',
          'arriveAirportName': '高崎机场',
          'departTerminal': 'T2',
          'arriveTerminal': 'T4',
          'airline': 'TV',
          'airlineName': '西藏航空',
          'flightNo': 'TV6908',
          'cabinName': '经济舱',
        },
        {
          'bookDate': '2023-05-11 16:18:06',
          'departDate': '2023-05-13',
          'departTime': '07:30',
          'arriveDate': '2023-05-13',
          'arriveTime': '14:55',
          'departCityName': '厦门',
          'departAirportName': '地窝堡机场',
          'arriveAirportName': '高崎机场',
          'departTerminal': 'T2',
          'arriveTerminal': 'T4',
          'airline': 'TV',
          'airlineName': '西藏航空',
          'flightNo': 'TV6908',
          'cabinName': '经济舱',
        }

      ]
    }
  },
  methods: {
    formatDate,
  }
}
</script>
<style lang="less" scoped>
.schedule-panel {
  color: #4d5059;
  border-radius: @border-radius-md;
  background-color: @color-background-white;
  padding: 12px 16px;
  padding-bottom: 24px;
}
.AlistOfSchedules{
  width: 100%;border-bottom: 1px dashed rgb(204, 204, 204);padding: 10px 0 10px 0;
}
</style>
